import { getCurrentCart as getCurrentEcomCart } from '@wix/ambassador-ecom-v1-cart/http';
import { BOOKINGS_APP_DEF_ID } from '@wix/bookings-adapter-ooi-wix-sdk';
import { queryExtendedBookings } from '@wix/ambassador-bookings-reader-v2-extended-booking/http';
export const getCurrentCart = async ({ httpClient, }) => {
    return (await httpClient.request(getCurrentEcomCart({}))).data;
};
const cartPopulator = async (cart, { httpClient }) => {
    const bookingIds = cart?.lineItems
        ?.filter((lineItem) => lineItem.catalogReference?.appId === BOOKINGS_APP_DEF_ID)
        .map((lineItem) => lineItem.catalogReference?.catalogItemId);
    if (!bookingIds || bookingIds?.length === 0) {
        return [];
    }
    try {
        const extendedBookings = (await httpClient.request(queryExtendedBookings({
            query: {
                filter: {
                    id: { $in: bookingIds },
                },
            },
        })))?.data?.extendedBookings || [];
        return extendedBookings;
    }
    catch (error) {
        throw new Error('An error occured trying to receive bookings from cart');
    }
};
export const getBookingsLineItemsOptions = async (config) => {
    const bookingsFromCurrentCart = await getBookingsFromCurrentCart(config);
    const options = bookingsFromCurrentCart.map((booking) => ({
        scheduleId: booking.bookedEntity?.schedule?.scheduleId,
        slot: booking.bookedEntity?.slot,
        tags: booking.bookedEntity?.tags,
        numberOfParticipants: booking.numberOfParticipants,
        contactDetails: booking.contactDetails,
    }));
    return options;
};
export const getBookingsFromCurrentCart = async (config) => {
    try {
        const currentCartResponse = await getCurrentCart(config);
        const currentCart = currentCartResponse?.cart;
        return (await cartPopulator(currentCart, config)).map((extendedBooking) => extendedBooking.booking);
    }
    catch (e) {
        return [];
    }
};
//# sourceMappingURL=getBookingsFromCurrentCart.js.map